module.exports = __webpack_public_path__ + "fbc8684244856ba254aca97d5179dff5.jpg";